import { useEffect, useRef } from 'react';
import HeapUtils from 'app/utils/heap';
import { getConnectNetwork } from 'app/modules/socialLogin/utils/connectTracking';
import { SocialLoginBusiness } from 'types/SocialLogin';

/**
 * Tracks, once, that the Safe Connect picker listed the person's portfolios —
 * the event the old portfolio step fired, now fired when the combined list
 * first shows (`isListed`).
 */
const useTrackOboPortfoliosListed = ({
  businesses,
  pageType,
  isListed,
}: {
  businesses: SocialLoginBusiness[] | undefined;
  pageType: number;
  isListed: boolean;
}) => {
  const hasTracked = useRef(false);
  const portfoliosCount = businesses?.length ?? 0;

  useEffect(() => {
    if (hasTracked.current || !isListed) {
      return;
    }

    hasTracked.current = true;
    HeapUtils.track(HeapUtils.events.CONNECT_PORTFOLIOS_LISTED, {
      network: getConnectNetwork(pageType),
      portfolios_available_count: portfoliosCount,
    });
  }, [isListed, portfoliosCount, pageType]);
};

export default useTrackOboPortfoliosListed;
